// extracted by mini-css-extract-plugin
export default {"header":"JW3Ax___App-module__header"};